import { IJoinBuSymbolInterface } from "./types";

export const joinBySymbol: IJoinBuSymbolInterface = (
  units: any[],
  symbol = "•"
): string => units.filter(Boolean).join(`${symbol}`);
